import React, { Component } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import { Tooltip, Modal, ModalHeader } from '../../../UiKit';
import {
  bike,
  ambulance,
  foodRed,
  foodBlue,
  delivered,
  cancelled,
  barCircle,
  redDottedLine,
  infoSvg,
  blueDottedLine,
  ambulanceRed,
} from '../../../images/svg';
import { timelineModel } from '../../../api';
import { OtofDetails, LogisticsTimings } from '../../tooltip';
import { BatchedDetails, CrystalView, DelaySummary } from '../../popups';
import './OrderTimeline.scss';
import {
  sendTimelineApiEvents,
  sendTimelineModalEvents,
  TIMELINE_EVENTS,
} from '../../../helpers/analytics/timeline.analytics';
import { EmergencyDrops } from '../Order/EmergencyDrops/EmergencyDrops';

const ignore_delay_for_markers = [
  'PROMISED_DELIVERY',
  'ESTIMATED_DELIVERY',
  // 'DELIVERED',
];
const dashboardMode = window.dashboard.mode;
let isSmartplug = dashboardMode === 'smartplug' ? true : false;

export default class OrderTimeline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeline: null,
      loader: false,
      lastPointer: '',
    };
    this.timer = null;
  }
  componentDidMount() {
    this.getTimelineData();
  }

  componentWillUnmount = () => {
    this.stopPolling();
    clearTimeout(this.timer);
  };

  stopPolling = () => {
    const { orderId, userId } = this.props;
    sendTimelineApiEvents(
      TIMELINE_EVENTS.TIMELINE_DETAILS_STOP_POLLING_EVENT,
      orderId,
      userId,
    );
    clearTimeout(this.timer);
  };

  startPolling = (interval) => {
    const { timeline } = this.state;
    const { orderId, userId } = this.props;
    if (!interval) {
      this.stopPolling();
      return;
    }
    this.setState({
      lastPointer: timeline?.activePointer,
    });
    let polling_freq = interval * 1000;
    this.timer = setTimeout(() => {
      sendTimelineApiEvents(
        TIMELINE_EVENTS.TIMELINE_DETAILS_START_POLLING_EVENT,
        orderId,
        userId,
      );
      this.setLoader(true);
      this.getTimelineData(true);
    }, polling_freq);
  };

  setLoader = (value) => {
    this.setState({
      loader: value,
    });
  };

  getTimelineData = (isPolling = false) => {
    const { orderId, userId } = this.props;
    const querryParams = {};
    querryParams['order_id'] = orderId;
    if (isPolling) {
      querryParams['is_polling'] = isPolling;
    }
    this.stopPolling();
    timelineModel
      .getTimelineData(querryParams)
      .then((response) => {
        if (!response || (response && response.isError === true)) {
          this.setLoader(false);
          return;
        }
        if (response?.polling_data?.is_applicable) {
          this.startPolling(response?.polling_data?.default_interval);
        }
        sendTimelineApiEvents(
          TIMELINE_EVENTS.GET_TIMELINE_DETAILS_SUCCESS,
          orderId,
          userId,
        );
        this.setLoader(false);
        this.makeTimelineData({ ...response });
      })
      .catch((err) => {
        sendTimelineApiEvents(
          TIMELINE_EVENTS.GET_TIMELINE_DETAILS_FAILURE,
          orderId,
          userId,
        );
        this.setLoader(false);
      });
  };

  orderClosed = (order_status, payment_status) => {
    return [7, 8].indexOf(order_status) !== -1 || payment_status === 0;
  };

  makeTimelineData = (raw_data) => {
    const { setIsTimelineUpdated, orderId } = this.props;
    var timeLineArray =
      typeof raw_data.tl !== 'undefined'
        ? raw_data.tl
            .filter((step) => step.type === 'state')
            .sort((a, b) => a.value_ts - b.value_ts)
        : [];
    var markers = [];
    var pointer = { icon: '', is_left: false, is_right: false };
    let lastPointer = this.state.lastPointer;
    let timeLineStatus = {};
    timeLineStatus[orderId] = false;
    timeLineArray.forEach(function (entity, index) {
      let entity_push = true;
      entity.is_active = false;

      //Make display text multi-line
      let display_text = entity.display_text ?? '';
      entity.display_text = display_text
        .trim()
        .split(' ')
        .map((item, index) => (
          <React.Fragment key={index}>
            <p>{item}</p>
          </React.Fragment>
        ));
      // entity.display_text = display_text.trim().split(" ").join('<br></br>');
      //If entity is poiter, put it on the timeline or active privious entity
      if (entity.key === 'pointer' || entity.is_pointer === true) {
        entity.is_active = true;
        if (
          lastPointer !== undefined &&
          lastPointer &&
          lastPointer !== display_text
        ) {
          timeLineStatus[orderId] = true;
          setIsTimelineUpdated(timeLineStatus);
        } else {
          setIsTimelineUpdated(timeLineStatus);
        }
        raw_data.activePointer = display_text;
        pointer = {
          icon: entity.icon,
          is_left: index === 0,
          is_right: index === timeLineArray.length - 1,
        };

        //Merge with previous entity when timestamps match — keep the pointer (current state)
        if (
          entity.icon !== 'failed' &&
          typeof markers[index - 1] !== 'undefined' &&
          markers[index - 1].value_ts === entity.value_ts
        ) {
          markers[index - 1] = entity;
          pointer.is_left = index === 1;
          entity_push = false;
        }
      }
      if (entity_push) markers.push(entity);
    });

    raw_data.markers = markers;
    raw_data.pointer = pointer;
    raw_data.cancelledOrRejectedText = '';
    if (this.orderClosed(raw_data.status, raw_data.payment_status)) {
      raw_data.cancelledOrRejectedText = raw_data.status_message;
    }

    //Order has KR tag and comment
    raw_data.has_kr = raw_data.kr ? true : false;
    this.setState({
      timeline: raw_data,
    });
  };

  render() {
    const { timeline, loader } = this.state;
    return (
      <div className='orderTimelineContainer tw-w-full tw-h-full'>
        {!timeline || loader ? (
          <Shimmer height='220px' width='100%' />
        ) : (
          <TimelineComp {...this.props} timeline={timeline} />
        )}
      </div>
    );
  }
}
export class TimelineComp extends React.Component {
  constructor(props) {
    super(props);
    this.pointerRef = React.createRef();
    this.ActiveMarkerRef = React.createRef();
    this.state = {
      pointerLeft: 0,
      completedWidth: 0,
      showBatchedDetails: false,
      BatchedDetails: null,
      showCrystalView: false,
      showDropLocationsView: false,
      crystalDetails: null,
      showDelaySummary: false,
    };
    this.delayText = '';
    this.delayStatus = '';
  }

  componentDidMount = () => {
    this.setTimelinePointer();
  };

  setTimelinePointer = () => {
    const { timeline } = this.props;
    const { pointer } = timeline;
    let leftOffset, completedWidth;
    if (typeof pointer === 'undefined') return;
    if (!this.ActiveMarkerRef.current && !this.pointerRef.current) return null;
    leftOffset =
      this.ActiveMarkerRef.current.getBoundingClientRect().left -
      this.ActiveMarkerRef.current.parentNode.getBoundingClientRect().left -
      this.pointerRef.current.getBoundingClientRect().width / 2 +
      this.ActiveMarkerRef.current.getBoundingClientRect().width / 2;
    completedWidth =
      this.ActiveMarkerRef.current.getBoundingClientRect().left -
      this.ActiveMarkerRef.current.parentNode.getBoundingClientRect().left +
      this.ActiveMarkerRef.current.getBoundingClientRect().width / 2;
    this.setState({
      pointerLeft: leftOffset,
      completedWidth: completedWidth,
    });
  };

  renderPointer = (pointer, everything_red) => {
    let progress_icon_class = 'zprogress-icon';
    let circle_ripple_class = '';
    switch (pointer.icon) {
      case 'bike':
        progress_icon_class += ' zprogress-icon-bike';
        circle_ripple_class = 'circle-ripple';
        break;
      case 'dish':
        progress_icon_class += ' zprogress-icon-dish';
        circle_ripple_class = 'circle-ripple';
        break;
      //no default
    }

    let svg = '';
    let barSvg = '';
    if (pointer.icon === 'bike') {
      svg = bike;
    } else if (pointer.icon === 'dish') {
      if (everything_red) {
        svg = foodRed;
      } else {
        svg = foodBlue;
      }
    } else if (pointer.icon === 'ambulance') {
      if (everything_red) {
        svg = ambulanceRed;
      } else {
        svg = ambulance;
      }
    }

    if (pointer.icon === 'ok') {
      barSvg = delivered;
    } else if (pointer.icon === 'failed') {
      barSvg = cancelled;
    } else {
      barSvg = barCircle;
    }

    const pointerStyle = {};
    pointerStyle.left = this.state.pointerLeft;
    return (
      <div
        className='zprogress-pointer'
        ref={this.pointerRef}
        style={pointerStyle}
      >
        <div className={progress_icon_class}>{svg}</div>
        <div className='rectangle-container'>
          <div className='rectangle-left'></div>
          <div className='rectangle-right'></div>
        </div>
        <div className={`zprogress-circle ${circle_ripple_class}`}>
          {barSvg}
        </div>
      </div>
    );
  };

  renderSingleMarker = (marker, index) => {
    const { timeline } = this.props;
    const ref = marker.is_active ? this.ActiveMarkerRef : null;
    // todo: remove this logic with delayText and status
    if (
      marker.is_delay &&
      ignore_delay_for_markers.indexOf(marker.key) !== -1
    ) {
      this.delayText = `${marker.delay_value} mins delayed`;
      this.delayStatus = 'delay';
    }
    if (
      marker.is_early &&
      ignore_delay_for_markers.indexOf(marker.key) !== -1
    ) {
      this.delayText = `${marker.delay_value} mins early`;
      this.delayStatus = 'early';
    }

    return (
      <React.Fragment key={index}>
        <div
          className={`single ${marker.is_active ? 'active' : ''}`}
          key={index}
          ref={ref}
        >
          {(marker.is_delay || marker.is_early || marker.delay_display_text) &&
          ignore_delay_for_markers.indexOf(marker.key) === -1 ? (
            <div className='delay-container'>
              <div className='delay'>
                <div className='delayTooltip'>
                  <Tooltip
                    position='bottom'
                    border={false}
                    title={
                      <p
                        className={`delay_title delay_title_smartplug ${
                          marker.is_early && 'is-early'
                        } ${marker.is_delay && 'is-delay'}`}
                      >
                        {marker.delay_display_text}
                      </p>
                    }
                    label={marker.delay_display_text}
                  />
                </div>
                {marker.delay_value ? (
                  <p
                    className={`delay_time
                  ${marker.is_early && 'is-early'}
                  ${marker.is_delay && ' is-delay'}
                  `}
                  >
                    {marker.delay_value} mins
                  </p>
                ) : (
                  <></>
                )}
              </div>
              {marker.is_early ? blueDottedLine : redDottedLine}
            </div>
          ) : null}
          {marker.display_time !== '' ? (
            <p className='time'>{marker.display_time}</p>
          ) : null}
          {marker.key === 'order_cancellation' ? (
            <span className='closedReason'>
              <Tooltip
                position='top'
                border={false}
                title={
                  <div className='title'>
                    <div className='title_text'>{marker.display_text}</div>
                    <span className='iconMarginL'>{infoSvg}</span>
                  </div>
                }
                label={timeline.cancelledOrRejectedText}
              />
            </span>
          ) : (
            <div className='title'>
              <div className='title_text'>{marker.display_text}</div>
            </div>
          )}

          {marker?.bottom_tag_text && marker.bottom_tag_text !== '' ? (
            <p className='bottom_tag'>{marker.bottom_tag_text}</p>
          ) : null}
        </div>
      </React.Fragment>
    );
  };

  getEstimations = () => {
    const { timeline } = this.props;
    const { event_time_popup } = timeline;
    if (!event_time_popup) return '';
    const { estimated, actual } = event_time_popup;
    if ((estimated && !estimated.length) || (actual && !actual.length))
      return '';
    const LogisticsTimingsWrapper = () => (
      <LogisticsTimings timmings={event_time_popup} />
    );
    LogisticsTimingsWrapper.displayName = 'LogisticsTimingsWrapper';
    return LogisticsTimingsWrapper;
  };

  getOtofInfo = () => {
    const { orderBasicInfo } = this.props;
    const otofData =
      orderBasicInfo && orderBasicInfo.order && orderBasicInfo.order.otof_data;
    if (!otofData) return '';
    const OtofDetailsWrapper = () => <OtofDetails details={otofData} />;
    OtofDetailsWrapper.displayName = 'OtofDetailsWrapper';
    return OtofDetailsWrapper;
  };

  getBatchedDetails = () => {
    const { orderId, userId } = this.props;
    const querryParams = {};
    querryParams['order_id'] = orderId;
    timelineModel.getBatchedDetails(querryParams).then((res) => {
      if (!res && res && res.isError) return null;
      sendTimelineModalEvents(
        TIMELINE_EVENTS.TIMELINE_BATCHED_DETAILS_MODAL_OPEN,
        orderId,
        userId,
      );
      this.setState({
        showBatchedDetails: true,
        batchedDetails: res,
      });
    });
  };

  closeBatchedDetails = () => {
    const { orderId, userId } = this.props;
    sendTimelineModalEvents(
      TIMELINE_EVENTS.TIMELINE_BATCHED_DETAILS_MODAL_CLOSE,
      orderId,
      userId,
    );
    this.setState({
      showBatchedDetails: false,
    });
  };

  openCrystalView = () => {
    this.setState({
      showCrystalView: true,
    });
  };

  setShowDropLocationsView = () => {
    this.setState({
      showDropLocationsView: true,
    });
  };

  closeCrystalView = () => {
    this.setState({
      showCrystalView: false,
    });
  };

  closeShowDropLocationsView = () => {
    this.setState({
      showDropLocationsView: false,
    });
  };

  viewDelaySummary = () => {
    const { timeline, orderId, userId } = this.props;
    const { delay_summary } = timeline;
    if (!delay_summary.post_pickup && !delay_summary.pre_pickup) {
      return;
    }
    sendTimelineModalEvents(
      TIMELINE_EVENTS.TIMELINE_DELAY_SUMMARY_MODAL_OPEN,
      orderId,
      userId,
    );
    this.setState({
      showDelaySummary: true,
    });
  };

  closeDelaySummary = () => {
    const { orderId, userId } = this.props;
    sendTimelineModalEvents(
      TIMELINE_EVENTS.TIMELINE_DELAY_SUMMARY_MODAL_CLOSE,
      orderId,
      userId,
    );
    this.setState({
      showDelaySummary: false,
    });
  };

  viewBatchSummary = () => {
    const { timeline, orderId, userId } = this.props;
    const { batch_summary } = timeline;
    if (!batch_summary.length) {
      return;
    }
    sendTimelineModalEvents(
      TIMELINE_EVENTS.TIMELINE_BATCHED_DETAILS_MODAL_OPEN,
      orderId,
      userId,
    );
    this.setState({
      showBatchedDetails: true,
    });
  };

  render() {
    const { timeline, orderId } = this.props;
    const {
      completedWidth,
      showBatchedDetails,
      showDelaySummary,
      showCrystalView,
      showDropLocationsView,
    } = this.state;
    const { pointer, delay_summary, is_live, is_emergency_order } = timeline;
    const { markers = [], timezone, total_delay, batch_summary } = timeline;

    const has_delays = total_delay > 0;

    let order_timeline_class = 'order-timeline';
    let timeline_bg = '';
    let everything_red = false;
    let completed_bar_width;
    const show_pointer = pointer.icon !== ''; //No icon if order failed
    switch (pointer.icon) {
      case 'failed':
        order_timeline_class += ' order-timeline-cancelled';
        everything_red = true;
        break;
      case 'ok':
        order_timeline_class += ' order-timeline-success';
        break;
      case 'ambulance':
        order_timeline_class += ' order-timeline-success';
        break;
      default:
        if (has_delays) {
          order_timeline_class += ' order-timeline-delay';
          everything_red = true;
        }
        break;
    }

    if (has_delays) {
      order_timeline_class += ' mt54';
    } else if (pointer.icon === 'ok') {
      //XOR operation
      order_timeline_class += ' mt32';
    }

    var progress_bar_class = 'zprogress';
    if (show_pointer) {
      if (pointer.is_right) progress_bar_class += ' zprogress-end';
      if (pointer.is_left) progress_bar_class += ' zprogress-begin';
    }

    if (everything_red) {
      timeline_bg = 'timeline_bg';
    }

    completed_bar_width = {
      width: completedWidth ? completedWidth : 0,
    };

    return (
      <div
        className={`timeline-comp main ${timeline_bg} tw-h-full tw-flex tw-w-full tw-justify-center tw-shadow-none tw-border-solid tw-border-[1px] tw-rounded-[8px] tw-border-grey-200`}
      >
        <div className='order-progress-head'>
          {timeline.is_live ? <AnimatePing /> : null}
          <div
            css={`
              span:nth-child(2) {
                margin-top: ${isSmartplug ? '' : '-20rem'};
              }
              span:nth-child(2)::after {
                margin-top: ${isSmartplug ? '' : '20rem'};
              }
            `}
          >
            <Tooltip
              position={isSmartplug ? 'bottom' : 'right'}
              title={
                <p className='lighter timeline-heading large relative'>
                  {timeline.is_live ? 'Live Order' : 'Order Progress'}
                </p>
              }
              titleColor='#828282'
              fontWeight={300}
              fontSize={14}
              label={this.getEstimations()}
            />
          </div>
        </div>
        {is_emergency_order ? (
          <div
            className='colorGreen tw-w-full'
            onClick={this.setShowDropLocationsView}
          >
            View Drop Locations
          </div>
        ) : (
          <></>
        )}

        <div className={order_timeline_class}>
          <div className={progress_bar_class}>
            {show_pointer && this.renderPointer(pointer, everything_red)}
            <div className='bar'>
              <div className='completed' style={completed_bar_width}></div>
            </div>
            <div className='zprogress-markers-container'>
              <div className='zprogress-timestamps'>
                {markers.map(this.renderSingleMarker)}
              </div>
              <div className='timezone'>
                <p>{timezone}</p>
              </div>
            </div>
          </div>
        </div>
        <div className='tw-flex tw-gap-x-2.5 tw-absolute tw-top-2.5 tw-right-2.5'>
          <React.Fragment>
            {/* show batched order tag */}
            {batch_summary && batch_summary.length ? (
              <div
                className={`delay_final small cursor`}
                onClick={this.viewBatchSummary}
              >
                <Tooltip
                  position='top'
                  border={false}
                  title={<p>{'Batched Order'}</p>}
                  label={'View Batch Details'}
                />
              </div>
            ) : null}
          </React.Fragment>

          {/* we will not be displaying delay summary for emergency orders */}
          {!is_emergency_order ? (
            <React.Fragment>
              {/* in case of  delay text | total delay  */}
              {this.delayText && total_delay === undefined && (
                <div
                  className={`delay_final small cursor ${this.delayStatus}`}
                  onClick={this.viewDelaySummary}
                >
                  <Tooltip
                    position='top'
                    border={false}
                    title={<p>{this.delayText}</p>}
                    label={
                      !delay_summary?.post_pickup && !delay_summary?.pre_pickup
                        ? ''
                        : 'View Summary'
                    }
                  />
                </div>
              )}
              {total_delay ? (
                <div
                  className={`delay_final small cursor ${
                    total_delay < 0 ? 'early' : 'delay'
                  }`}
                  onClick={this.viewDelaySummary}
                >
                  <Tooltip
                    position='top'
                    border={false}
                    title={
                      <p>
                        {total_delay < 0
                          ? `${Math.abs(total_delay)} mins early`
                          : `${Math.abs(total_delay)} mins delayed`}
                      </p>
                    }
                    label={'View Summary'}
                  />
                </div>
              ) : null}
            </React.Fragment>
          ) : (
            <></>
          )}
        </div>

        <Tooltip
          position='top'
          border={false}
          title={
            <div>
              <p
                className={` pointer large inlineFlex ${
                  is_live ? 'green' : 'tw-text-grey-400'
                }`}
                onClick={this.openCrystalView}
              >
                Live Order View
              </p>
            </div>
          }
          label={`${
            is_live ? 'Track Live Order' : 'Applicable for live orders only'
          }`}
        />

        {showBatchedDetails ? (
          <Modal
            isVisible={showBatchedDetails}
            type='large'
            title='Batched order details'
            handleClose={this.closeBatchedDetails.bind(this)}
            component={<BatchedDetails details={batch_summary} />}
          />
        ) : null}
        {showCrystalView && is_live ? (
          <Modal
            type={isSmartplug ? 'large' : 'medium'}
            isVisible={showCrystalView}
            maxHeight='80vh'
            minHeight='80vh'
            titleComponent={
              <ModalHeader
                title='Live Order View'
                handleClose={this.closeCrystalView.bind(this)}
                padding='2rem'
              />
            }
            padding='0rem'
            paddingTop='0'
            marginTop={0}
            isMaxContent={true}
            showCloseIcon={false}
            handleClose={this.closeCrystalView.bind(this)}
            component={
              <CrystalView
                orderId={orderId}
                isLiveOrder={is_live}
                orderBasicInfo={this.props?.orderBasicInfo}
              />
            }
          />
        ) : null}
        {showDelaySummary && delay_summary ? (
          <Modal
            isVisible={showDelaySummary}
            type='medium'
            maxHeight='inherit'
            title={delay_summary?.title}
            isMaxContent={true}
            handleClose={this.closeDelaySummary.bind(this)}
            component={
              <DelaySummary
                details={delay_summary}
                serviceabilityUrl={timeline?.serviceability_db_url}
              />
            }
          />
        ) : null}
        {showDropLocationsView ? (
          <Modal
            type='large'
            isVisible={showDropLocationsView}
            titleComponent={
              <ModalHeader
                title='Drop Locations'
                handleClose={this.closeShowDropLocationsView.bind(this)}
                padding='2rem'
              />
            }
            padding='0'
            paddingTop='0'
            marginTop={0}
            isMaxContent={true}
            showCloseIcon={false}
            handleClose={this.closeShowDropLocationsView.bind(this)}
            component={<EmergencyDrops orderId={orderId} />}
          />
        ) : null}
      </div>
    );
  }
}

function AnimatePing({ color = '#50b547' }) {
  return (
    <span
      css={`
        display: flex;
        height: 1rem;
        width: 1rem;
        align-self: center;
        position: relative;
      `}
    >
      <span
        css={`
          position: absolute;
          display: inline-flex;
          height: 100%;
          width: 100%;
          border-radius: 9999px;
          background: ${color};
          opacity: 0.75;
          animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
          @keyframes ping {
            75%,
            100% {
              transform: scale(2.5);
              opacity: 0;
            }
          }
        `}
      ></span>
      <span
        css={`
          position: relative;
          display: inline-flex;
          border-radius: 50%;
          border-radius: 9999px;
          background: ${color};
          height: 1rem;
          width: 1rem;
        `}
      ></span>
    </span>
  );
}
